var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkAuthorization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1127 13.8302H19.9761C18.8619 13.8271 17.8422 13.7862 16.76 13.7076C17.411 10.6626 18.5426 7.74113 20.1125 5.05269C21.6827 7.74772 22.8147 10.6752 23.4661 13.726C22.1612 13.8301 21.0151 13.8302 20.1127 13.8302Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5919 13.5372C24.9124 10.3428 23.7363 7.27516 22.1073 4.44609C24.4708 4.7373 26.7408 5.5576 28.7473 6.84887L28.7473 6.84887C30.8014 8.1706 32.521 9.94825 33.7734 12.042C31.0931 12.7702 28.3564 13.2706 25.5919 13.5372Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4602 6.73917C13.4677 5.43446 15.7425 4.6026 18.1133 4.30306C16.4761 7.15673 15.2994 10.2518 14.6275 13.4739C11.8616 13.211 9.12381 12.7105 6.44414 11.9781C7.68815 9.86885 9.40457 8.07524 11.4602 6.73917Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9383 15.6057C28.9245 15.2896 31.8771 14.7105 34.7614 13.8751C35.562 15.8021 35.9747 17.8688 35.9747 19.9573C35.9747 22.0665 35.5538 24.1539 34.7374 26.0972C31.8609 25.2655 28.9165 24.6888 25.9385 24.3736C26.1506 22.9224 26.2623 21.4583 26.2728 19.9914L26.2728 19.9877C26.2613 18.5211 26.1495 17.0568 25.9383 15.6057Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9237 15.8144C24.128 17.1978 24.2339 18.5938 24.2405 19.9923C24.2362 21.3899 24.1306 22.7852 23.9245 24.1674C22.4295 24.0421 21.0956 24.0421 20.1923 24.0421H20.1903C18.8976 24.0421 17.6487 24.0991 16.457 24.1863C16.251 22.7978 16.1452 21.3961 16.1406 19.9923C16.147 18.5918 16.2524 17.1937 16.4558 15.8083C17.6545 15.9422 18.9055 15.9422 20.1815 15.9422H20.1906C21.0978 15.9422 22.4032 15.9276 23.9237 15.8144Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9519 19.9896H13.9519V19.9916L13.9519 19.9917L13.9519 19.9929C13.9594 21.481 14.0711 22.9667 14.2861 24.439C11.3061 24.7404 8.36034 25.3175 5.48687 26.1626C4.67077 24.2196 4.25 22.1329 4.25 20.024C4.25 17.915 4.67076 15.8281 5.48687 13.885C8.36033 14.7303 11.3061 15.3073 14.2862 15.6089C14.0752 17.0596 13.9634 18.5235 13.9519 19.9896Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1127 26.1525C21.0122 26.1525 22.16 26.1667 23.4672 26.2596C22.8329 29.3157 21.6996 32.2462 20.1131 34.9338C18.5315 32.2458 17.3979 29.3179 16.7568 26.2648C17.7539 26.1606 18.779 26.1529 19.8627 26.1524V26.1525H20.1127Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44338 27.9405C9.12669 27.1999 11.8708 26.6994 14.6432 26.4449C15.3114 29.6758 16.4934 32.7777 18.1437 35.633C15.7661 35.3361 13.4847 34.5038 11.4717 33.1963C9.40967 31.857 7.68873 30.0573 6.44338 27.9405Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7615 28.0202C32.5158 30.132 30.7966 31.9276 28.7375 33.264L28.7375 33.264C26.728 34.5685 24.4503 35.3995 22.077 35.6969C23.7335 32.8229 24.916 29.7 25.5781 26.4485C28.3443 26.7483 31.0812 27.274 33.7615 28.0202Z",
    fill: "#EC923C",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkAuthorization);
export default __webpack_public_path__ + "static/media/workAuthorization.7505ae7e.svg";
export { ForwardRef as ReactComponent };